import { Col, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import Title from 'antd/lib/typography/Title';
import { LanguageContext } from 'contexts/LanguageContext';
import React, { useContext } from 'react';

export default function SavingCampaign() {
	const { dictionary } = useContext(LanguageContext);

	return (
		<>
			<Row style={{ height: 100, paddingTop: '2em' }}>
				<Title level={2}>
					<Text type="gray-9">{dictionary.saving_campaign}</Text>
				</Title>
			</Row>
		</>
	);
}
